package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.EditNoteW500Rounded: ImageVector
    get() {
        if (_editNoteW500Rounded != null) {
            return _editNoteW500Rounded!!
        }
        _editNoteW500Rounded = Builder(name = "EditNoteW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(197.37f, 577.7f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.18f)
                quadToRelative(-13.17f, -13.17f, -13.17f, -32.32f)
                quadToRelative(0.0f, -19.16f, 13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(203.59f)
                quadToRelative(19.15f, 0.0f, 32.32f, 13.17f)
                quadToRelative(13.18f, 13.17f, 13.18f, 32.33f)
                quadToRelative(0.0f, 19.15f, -13.18f, 32.32f)
                quadToRelative(-13.17f, 13.18f, -32.32f, 13.18f)
                lineTo(197.37f, 577.7f)
                close()
                moveTo(197.37f, 410.28f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                reflectiveQuadToRelative(13.17f, -32.32f)
                quadToRelative(13.18f, -13.18f, 32.33f, -13.18f)
                horizontalLineToRelative(360.0f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.18f)
                quadToRelative(13.17f, 13.17f, 13.17f, 32.32f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                horizontalLineToRelative(-360.0f)
                close()
                moveTo(197.37f, 242.87f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(360.0f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadTo(589.7f, 229.7f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                horizontalLineToRelative(-360.0f)
                close()
                moveTo(518.57f, 762.63f)
                verticalLineToRelative(-65.04f)
                quadToRelative(0.0f, -9.2f, 3.47f, -17.54f)
                quadToRelative(3.48f, -8.33f, 10.2f, -15.05f)
                lineTo(741.0f, 457.0f)
                quadToRelative(9.72f, -9.72f, 21.55f, -14.08f)
                quadToRelative(11.84f, -4.35f, 23.8f, -4.35f)
                quadToRelative(12.95f, 0.0f, 24.79f, 4.85f)
                quadToRelative(11.84f, 4.86f, 21.56f, 14.58f)
                lineToRelative(37.0f, 37.0f)
                quadToRelative(8.71f, 9.72f, 13.57f, 21.55f)
                quadToRelative(4.86f, 11.84f, 4.86f, 23.8f)
                quadToRelative(0.0f, 12.19f, -4.36f, 24.41f)
                reflectiveQuadTo(869.7f, 586.7f)
                lineToRelative(-208.0f, 208.0f)
                quadToRelative(-6.72f, 6.71f, -15.06f, 10.07f)
                quadToRelative(-8.34f, 3.36f, -17.53f, 3.36f)
                horizontalLineToRelative(-65.04f)
                quadToRelative(-19.16f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                close()
                moveTo(823.35f, 540.35f)
                lineTo(786.35f, 503.35f)
                lineTo(823.35f, 540.35f)
                close()
                moveTo(583.35f, 743.35f)
                horizontalLineToRelative(38.0f)
                lineTo(741.39f, 622.3f)
                lineToRelative(-18.0f, -19.0f)
                lineToRelative(-19.0f, -18.0f)
                lineToRelative(-121.04f, 120.05f)
                verticalLineToRelative(38.0f)
                close()
                moveTo(723.39f, 603.3f)
                lineToRelative(-19.0f, -18.0f)
                lineToRelative(37.0f, 37.0f)
                lineToRelative(-18.0f, -19.0f)
                close()
            }
        }
        .build()
        return _editNoteW500Rounded!!
    }

private var _editNoteW500Rounded: ImageVector? = null
